import { LicenseInfo } from '@mui/x-data-grid-premium'

export const setMUILicenseKey = () => {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE || '')
}
